(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-hoops-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initFloatingHoops(scope) {
      const roots = [];
      if (scope.matches && scope.matches('[data-fhc-root]')) roots.push(scope);
      if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-fhc-root]'));

      roots.forEach(root => {
        if (root.dataset.fhcInitialized === 'true') return;
        root.dataset.fhcInitialized = 'true';

        const viewport = root.querySelector('[data-fhc-viewport]');
        const rail = root.querySelector('[data-fhc-rail]');
        const original = root.querySelector('[data-fhc-original]');
        const button = root.querySelector('[data-fhc-toggle]');
        if (!viewport || !rail || !original || !original.querySelector('.fhc__link')) return;

        // Reduced-motion visitors get a static, finger-scrollable row.
        if (reduceMotion.matches) return;

        viewport.classList.add('fhc__viewport--animated');
        button.hidden = false;
        const speed = Math.max(10, Number(root.dataset.fhcSpeed) || 35);
        let unitWidth = 0;
        let x = 0;
        let paused = Boolean(window.Shopify && window.Shopify.designMode);
        let hovering = false;
        let keyboardFocus = false;
        let touching = false;
        let visible = true;
        let previousFrame = 0;
        let startX = 0;
        let startY = 0;
        let lastTouchX = 0;
        let horizontalGesture = false;
        let suppressClickUntil = 0;

        function normalize() {
          if (!unitWidth) return;
          x = ((x % unitWidth) + unitWidth) % unitWidth;
          if (x > 0) x -= unitWidth;
        }

        function draw() { rail.style.transform = `translate3d(${x}px, 0, 0)`; }

        function buildClones() {
          rail.querySelectorAll('[data-fhc-clone]').forEach(node => node.remove());
          unitWidth = original.getBoundingClientRect().width;
          if (!unitWidth) return;
          const copies = Math.max(2, Math.ceil(viewport.clientWidth / unitWidth) + 2);
          for (let i = 1; i < copies; i++) {
            const clone = original.cloneNode(true);
            clone.removeAttribute('data-fhc-original');
            clone.setAttribute('data-fhc-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach(link => link.setAttribute('tabindex', '-1'));
            // Shopify editor block IDs must belong only to the original set.
            clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
            rail.appendChild(clone);
          }
          normalize();
          draw();
        }

        function updateButton() {
          button.textContent = paused ? 'Play animation' : 'Pause animation';
          button.setAttribute('aria-pressed', String(paused));
        }

        button.addEventListener('click', () => { paused = !paused; updateButton(); });
        updateButton();

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          viewport.addEventListener('mouseenter', () => { hovering = true; });
          viewport.addEventListener('mouseleave', () => { hovering = false; });
        }

        viewport.addEventListener('focusin', event => {
          keyboardFocus = true;
          const item = event.target.closest('.fhc__item');
          if (!item || !original.contains(item) || !unitWidth) return;
          // Keyboard navigation must reveal original items even as the rail loops.
          const bounds = item.getBoundingClientRect();
          const viewBounds = viewport.getBoundingClientRect();
          if (bounds.left < viewBounds.left + 12) {
            x += viewBounds.left + 12 - bounds.left;
          } else if (bounds.right > viewBounds.right - 12) {
            x -= bounds.right - (viewBounds.right - 12);
          }
          x = Math.min(0, x);
          normalize();
          draw();
        });
        viewport.addEventListener('focusout', () => {
          requestAnimationFrame(() => { keyboardFocus = viewport.contains(document.activeElement); });
        });

        viewport.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) return;
          touching = true;
          horizontalGesture = false;
          startX = lastTouchX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });

        viewport.addEventListener('touchmove', event => {
          if (!touching || event.touches.length !== 1) return;
          const currentX = event.touches[0].clientX;
          const currentY = event.touches[0].clientY;
          if (!horizontalGesture && Math.abs(currentX - startX) > 8 && Math.abs(currentX - startX) > Math.abs(currentY - startY)) {
            horizontalGesture = true;
          }
          if (horizontalGesture) {
            event.preventDefault();
            x += currentX - lastTouchX;
            normalize();
            draw();
          }
          lastTouchX = currentX;
        }, { passive: false });

        function finishTouch() {
          if (horizontalGesture) suppressClickUntil = performance.now() + 350;
          touching = false;
          horizontalGesture = false;
        }
        viewport.addEventListener('touchend', finishTouch, { passive: true });
        viewport.addEventListener('touchcancel', finishTouch, { passive: true });

        viewport.addEventListener('click', event => {
          if (performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: 0.01 });
          observer.observe(root);
        }
        if ('ResizeObserver' in window) {
          const resize = new ResizeObserver(() => buildClones());
          resize.observe(viewport);
        } else {
          window.addEventListener('resize', buildClones);
        }

        buildClones();

        function frame(now) {
          if (!root.isConnected) return;
          const dt = previousFrame ? Math.min((now - previousFrame) / 1000, .06) : 0;
          previousFrame = now;
          if (visible && !reduceMotion.matches && !paused && !hovering && !keyboardFocus && !touching && unitWidth) {
            x -= speed * dt;
            normalize();
            draw();
          }
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initFloatingHoops(document));
    } else {
      initFloatingHoops(document);
    }
    document.addEventListener('shopify:section:load', event => initFloatingHoops(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksc-etsy-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ksc-etsy-reviews')){
customElements.define('ksc-etsy-reviews',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.track=this.querySelector('.ksc-track');if(!this.track)return;
  this.cards=[...this.track.children];this.prev=this.querySelector('.ksc-prev');this.next=this.querySelector('.ksc-next');
  this.reviewControls=[...this.querySelectorAll('.ksc-review-copy')].map(copy=>({quote:copy.querySelector('.ksc-quote'),button:copy.querySelector('.ksc-review-toggle')}));
  const fullHeights=this.reviewControls.map(({quote})=>quote.scrollHeight);
  this.classList.add('is-enhanced');
  requestAnimationFrame(()=>this.reviewControls.forEach(({quote,button},index)=>{button.hidden=fullHeights[index]<=quote.clientHeight+1}));
  this.reviewControls.forEach(({quote,button})=>button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';quote.classList.toggle('is-expanded',!expanded);button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?button.dataset.readMoreLabel:button.dataset.showLessLabel;requestAnimationFrame(()=>this.update())},opts));
  this.prev.addEventListener('click',()=>this.move(-1),opts);this.next.addEventListener('click',()=>this.move(1),opts);
  this.track.addEventListener('scroll',()=>this.update(),{...opts,passive:true});
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();if(e.key==='Home'||e.key==='End')this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:this.behavior()});else this.move(e.key==='ArrowLeft'?-1:1)}},opts);
  this.querySelectorAll('img').forEach(img=>img.addEventListener('error',()=>{if(img.closest('.ksc-avatar'))img.remove();else img.closest('.ksc-photo-button')?.setAttribute('hidden','')},opts));
  this.dialog=this.querySelector('dialog');
  this.querySelectorAll('.ksc-photo-button').forEach(b=>b.addEventListener('click',()=>{const img=b.querySelector('img');const large=this.dialog.querySelector('img');large.src=img.src;large.alt=img.alt;this.dialog.showModal()},opts));
  this.querySelector('.ksc-close').addEventListener('click',()=>this.dialog.close(),opts);
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},opts);
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.ksc-card');if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'})},opts);
  this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect()}
 behavior(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}
 move(dir){const gap=parseFloat(getComputedStyle(this.track).gap)||0;const step=this.cards[0]?.getBoundingClientRect().width+gap;if(step)this.track.scrollBy({left:dir*step,behavior:this.behavior()})}
 update(){const max=this.track.scrollWidth-this.track.clientWidth;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=max-2;this.prev.hidden=this.next.hidden=max<=2}
});}


  } catch(e) { console.error(e); }
})();
})();
